import { CSSProperties } from 'react'
import styled from 'styled-components'

const readable = (date: string, lang: 'de' | 'fr') => {

  return new Date(date).toLocaleDateString(lang === 'de' ? 'ch-DE' : 'fr-FR', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}

export const YTick = ({
  y,
  x1,
  x2,
  style,
  label,
  lang = 'de',
}: {
  y: number
  x1: number
  x2: number
  style?: CSSProperties
  label?: string
  lang?: 'de' | 'fr'
}) => {
  const col = label && new Date(label) > new Date('2021-12-01')

  return (
    <>
      {label && col && (
        <TickTextSB y={y + 20} x={6}>
          {readable(label, lang)}
        </TickTextSB>
      )}
      {label && !col && (
        <TickTextTC y={y + 20} x={6}>
          {readable(label, lang)}
        </TickTextTC>
      )}
      {col && <TicklinSB x1={x1} x2={x2} y1={y} y2={y} style={style} />}
      {!col && <TicklinTC x1={x1} x2={x2} y1={y} y2={y} style={style} />}
    </>
  )
}

const TickLine = styled.line`
  stroke-width: 2;

  stroke: var(--text-color);
  opacity: 0.5;
  stroke-width: 1;
`

const TicklinSB = styled(TickLine)`
  stroke: var(--site-background);
  opacity: 0.75;
`
const TicklinTC = styled(TickLine)`
  stroke: var(--text-color);
`
const TickText = styled.text`
  font-size: 12px;
  fill: var(--text-color);
  opacity: 0.75;
`
const TickTextSB = styled(TickText)`
  fill: var(--site-background);
  opacity: 0.75;
`
const TickTextTC = styled(TickText)`
  fill: var(--text-color);
`
